<template>
    <div :class="[size]">
        <font-awesome-icon icon="chalkboard-teacher" class="mr-1"></font-awesome-icon>
        {{ group.group_name }}
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    props: {
        size: {
            type: String,
            default: 'md',
            validator(value) {
                return ['sm', 'md', 'lg'].includes(value);
            }
        }
    },
    computed: mapState(["group"])
}
</script>
<style scoped>
    .sm {
        font-size: 12px;
    }
    .md {
        font-size: 18px;
    }
    .lg {
        font-size: 32px;
    }
</style>